import React, { VFC } from 'react';

import { LOGIN } from '../../constants';
import { Button, Modal } from '../common';
import { LoginStatusProps } from './types';

const LoginSuccess: VFC<LoginStatusProps> = ({ onRequestClose, onConfirm }) => (
  <Modal
    size="fit"
    isXButton={false}
    isShow
    onClose={onRequestClose}
    title={LOGIN.LOGIN_SUCCESS_TITLE}
    explanation={LOGIN.LOGIN_SUCCESS_CONTENT}
    footerComponent={<Button onClick={onConfirm} title="OK" />}
  />
);

export default LoginSuccess;
